import dayjs from 'dayjs'

const formatDate = (start, end) => {
  let startDate = dayjs(start)
  let endDate = dayjs(end)

  if (startDate.year() !== endDate.year()) {
    return `${startDate.format('D MMM, YYYY')} - ${endDate.format('D MMM, YYYY')}`
  }

  if (startDate.month() !== endDate.month()) {
    return `${startDate.format('D MMM')} - ${endDate.format('D MMM, YYYY')}`
  }

  return `${startDate.format('D')} - ${endDate.format('D MMM, YYYY')}`
}

export default formatDate
